import React from "react";

/**
 * Animated ARIA neural orb. Pulls colors from CSS variables so it tracks the
 * global palette (Quartz Spectroscopy: teal + magenta). The optional `color`
 * prop, when provided, is exposed as a CSS custom property only — the inner
 * magenta ember and outer teal glow stay intact.
 *
 * states: idle | listening | thinking
 */
export function AriaOrb({ state = "idle", size = 48, color, className = "" }) {
  const style = { width: size, height: size };
  if (color) style["--aria-orb-tint"] = color;
  return (
    <div
      className={`aria-orb ${state} ${className}`}
      style={style}
      data-testid="aria-orb"
      aria-label={`ARIA ${state}`}
    />
  );
}
